// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1vgQv","buttons":"RemoveExpirationActionButtons_buttons__1lEYt"};